/* eslint-disable */
import React from 'react';
import { Box, Stack, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 18,
    },
}));

const UserModPermission = (props) =>
{
    const { value, header } = props;
    const classes = useStyles();
    return (
        <>
            {!header ? (
                <Box display="flex" flexDirection="row">
                    <Stack spacing={1} direction="row">
                        <Tooltip title={''} aria-label={''}>
                            <RemoveCircleRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: value.permission == 0 ? theme.palette.error.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserPermission(props.rowIndex, props.colIndex, props.column, 0)}
                            />
                        </Tooltip>
                        <Tooltip
                            title={''}
                            aria-label={''}>
                            <VisibilityRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: value.permission == 1 ? theme.palette.warning.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserPermission(props.rowIndex, props.colIndex, props.column, 1)}
                            />
                        </Tooltip>
                        <Tooltip
                            title={''}
                            aria-label={''}>
                            <CheckCircleRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: value.permission == 2 ? theme.palette.success.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserPermission(props.rowIndex, props.colIndex, props.column, 2)}
                            />
                        </Tooltip>
                    </Stack>
                </Box>
            ) : (
                <Box display="flex" flexDirection="row">
                    <Stack spacing={1} direction="row">
                        <Tooltip title={''} aria-label={''}>
                            <RemoveCircleRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: props.column.permission == 0 ? theme.palette.error.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserHeadPermission(props.colIndex, props.column, 0)}
                            />
                        </Tooltip>
                        <Tooltip
                            title={''}
                            aria-label={''}>
                            <VisibilityRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: props.column.permission == 1 ? theme.palette.warning.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserHeadPermission(props.colIndex, props.column, 1)}
                            />
                        </Tooltip>
                        <Tooltip
                            title={''}
                            aria-label={''}>
                            <CheckCircleRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: props.column.permission == 2 ? theme.palette.success.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserHeadPermission(props.colIndex, props.column, 2)}
                            />
                        </Tooltip>
                    </Stack>
                </Box>
            )}
        </>
    );
};

export default UserModPermission;
